<script>
    import Fa from 'svelte-fa';
    import { faCircleNotch, faBullseye, faTag } from '@fortawesome/pro-regular-svg-icons';

    import { debounce } from '$lib/utils/functions/debounce';
    import { formatMoney } from '$lib/utils/functions/money.js';

    import Picture from '$lib/components/Picture.svelte';
    import QtyButton from '$lib/components/QtyButton.svelte';

    export let item;
    export let cartUpdating;

    let lineItemUpdating = false;
    let maxQty = item?.merchandise?.quantityAvailable;

    // update cart
    async function updateCart(newQty) {
        cartUpdating = true;
        lineItemUpdating = true;
        lineItemUpdating = await window.cart.updateCart(item.id, newQty); // function returns false
        cartUpdating = lineItemUpdating;
    }

    // trigger updateCart() in debounce & set timeout
    const debouncedUpdateCart = debounce(updateCart, 600);

    // insert updateCart() click functions into QtyButton Component
    const qtyClicks = {
        minusClick: (newQty) => {
            if (newQty < maxQty) {
                debouncedUpdateCart(newQty);
            }
        },
        plusClick: (newQty) => {
            if (newQty < maxQty + 1) {
                debouncedUpdateCart(newQty);
            }
        }
    };

    let compareAtPrice = item?.merchandise?.compareAtPrice?.amount;
    let productPrice = item?.merchandise?.price?.amount;
</script>

<div
    class="flex flex-col gap-3 overflow-hidden rounded-lg border border-base-900/5 bg-base-900 p-4 shadow-sm transition-all delay-200 ease-in-out dark:bg-base-800"
>
    <div class="grid grid-cols-12 items-start gap-2.5">
        <div class="col-span-9 flex flex-col gap-3">
            <div>
                <div class="text-base font-medium dark:text-purple-300">
                    {item?.merchandise?.product?.title}
                </div>
                <span class="block text-xs">By {item?.merchandise?.product?.vendor}</span>
            </div>
            <span class="block text-sm text-color-text/80">{item?.merchandise?.title}</span>
        </div>

        <div class="col-span-3">
            {#if lineItemUpdating}
                <div class="flex aspect-square items-center justify-center rounded-lg">
                    <Fa icon={faCircleNotch} size="2x" spin={true} class="text-color-text" />
                </div>
            {:else}
                <Picture src={item?.merchandise?.image?.url} alt={item?.merchandise?.product?.title} width="80" height="80" imageSizes={[200, 250, 300]} />
            {/if}
        </div>
    </div>

    <div class="grid grid-cols-12 items-center gap-2.5">
        <div class="col-span-6">
            <QtyButton {maxQty} trash={true} disabled={cartUpdating} addFunctionToClicks={qtyClicks} bind:itemQty={item.quantity} />
        </div>

        <div class="col-span-6 text-right">
            {#each item?.discountAllocations as discount (discount)}
                {#if discount?.title}
                    <span class="inline-block text-xs font-semibold text-color-text/80">
                        <Fa icon={faBullseye} size="1x" class="mr-1 inline-block text-purple-300" />
                        Club Deal
                    </span>
                    <span class="inline-block text-xs text-color-text/60 line-through">
                        {formatMoney(item?.cost?.subtotalAmount?.amount)}
                    </span>
                {:else if discount?.code && item?.cost?.subtotalAmount?.amount > item?.cost?.totalAmount?.amount}
                    <span class="inline-block text-xs font-semibold text-color-text/80">
                        <Fa icon={faTag} size="1x" class="mr-1 inline-block text-purple-300" />
                        Discount
                    </span>
                    <span class="inline-block text-xs text-color-text/60 line-through">
                        {formatMoney(item?.cost?.subtotalAmount?.amount)}
                    </span>
                {/if}
            {/each}

            {#if compareAtPrice && compareAtPrice > productPrice}
                <span class="inline-block text-xs font-semibold text-color-text/80">
                    <Fa icon={faTag} size="1x" class="mr-1 inline-block text-purple-300" />
                    Discount
                </span>
                <span class="inline-block text-xs text-color-text/60 line-through">
                    {formatMoney(compareAtPrice * item?.quantity)}
                </span>
            {/if}
            <div class="text-base font-medium">
                {#if item?.cost?.totalAmount?.amount > 0}
                    {item?.cost?.totalAmount?.currencyCode}
                    {formatMoney(item?.cost?.totalAmount?.amount)}
                {:else}
                    Free
                {/if}
            </div>
        </div>
    </div>
</div>
